import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\resources\\page.js");
